if (!customElements.get('plate-box')) {
  customElements.define('plate-box', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const root = this.closest('.plate-layout');
      const panels = [...this.querySelectorAll('[data-plate-box-variant]')];
      const sync = () => {
        const values = [...root.querySelectorAll('.content-column select[name^="options["]')].map(select => select.value);
        const panel = panels.find(item => JSON.stringify(JSON.parse(item.dataset.options)) === JSON.stringify(values));
        if (!panel) return;
        panels.forEach(item => { item.hidden = item !== panel; });
        const photo = root.querySelector('[data-flask-zoom]');
        const img = photo?.querySelector('img');
        if (img && photo.dataset.flaskZoom !== panel.dataset.zoomImage) {
          photo.dataset.flaskZoom = panel.dataset.zoomImage;
          img.removeAttribute('srcset');
          img.src = panel.dataset.image;
          img.alt = panel.dataset.alt;
          const thumb = root.querySelector('[data-photo-index="0"] img');
          if (thumb) { thumb.removeAttribute('srcset'); thumb.src = panel.dataset.image.replace('width=1400', 'width=120'); }
        }
      };
      root.addEventListener('change', event => {
        if (event.target.matches('select[name^="options["]')) sync();
      }, {signal: this.abort.signal});
      sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
